/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import styled from "@emotion/styled";
import Div100vh from "react-div-100vh";

// Images
import css from "@emotion/css";
import ImgBackgroundPhoneCarrierProduct from "../Images/PhoneCarrier/ImgBackgroundPhoneCarrierProduct";
import ImgWuitusu from "../../images/phone-carrier/phone-carrier-wuitusu-logo.png";
import ImgSponsor from "../../images/phone-carrier/phone-carrier-sponsor-shirt.jpg";

import ImgProductOne from "../../images/phone-carrier/phone-carrier-product-1.jpg";
import ImgProductTwo from "../../images/phone-carrier/phone-carrier-product-2.png";
import { mediaQueries } from "../../configs/_configSite";
import FireFly from "../Animations/FireFly";
import { LinkPurchaseExt } from "../Base/links/LinkPurchase";

const ContainerMain = styled(Div100vh)`
  position: relative;
  height: 100vh;
  width: 100vw;
`;

const ProductContainer = styled.section`
  position: absolute;
  z-index: 1;
  top: 12vh;
  right: 9vw;

  @media (max-width: ${mediaQueries.lg}px) {
    top: 15vh;
    right: 0;
  }

  @media (max-width: ${mediaQueries.md}px) {
    width: 50%;
    transform: scale(0.9);
    width: calc(100% - 250px);
  }

  @media (max-width: ${mediaQueries.xs}px) {
    top: 0;
    transform: scale(0.75);
    width: 100%;
    right: -40px;
  }
`;

const ProductWrapper = styled.section`
  position: relative;
  padding: 15px;
  width: 600px;

  &:nth-of-type(1) {
    margin-bottom: 180px;
  }

  @media (max-width: ${mediaQueries.lg}px) {
    &:nth-of-type(1) {
      margin-bottom: 175px;
    }
  }

  @media (max-width: ${mediaQueries.md}px) {
    width: calc(100% - 30px);
  }

  @media (max-width: ${mediaQueries.xs}px) {
    &:nth-of-type(1) {
      margin-bottom: 5vh;
    }
  }
`;

const Image = styled.div`
  position: absolute;
  top: -50px;
  width: 250px;
  height: 350px;
  left: -260px;

  @media (max-width: ${mediaQueries.lg}px) {
    top: -50px;
    width: 250px;
    height: 350px;
    left: -260px;
  }

  @media (max-width: ${mediaQueries.xs}px) {
    top: 0px;
    width: 100px;
    height: 200px;
    left: -110px;
  }
`;

const Title = styled.h1`
  font-family: Assistant;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0;
  margin-bottom: 15px;
`;

const Text = styled.p`
  font-family: Assistant;
  font-size: 1rem;
`;

const FooterSponsor = styled.a`
  position: absolute;
  display: block;
  z-index: 2;

  width: 250px;
  height: 100px;

  bottom: 5vh;
  right: calc(50% - 250px);

  background: url(${ImgSponsor}) no-repeat center / contain;

  @media (max-width: 1400px) {
    right: 500px;
  }
  @media (max-width: ${mediaQueries.lg}px) {
    right: 300px;
  }
  @media (max-width: ${mediaQueries.md}px) {
    right: calc(50% - 250px);
  }
  @media (max-width: ${mediaQueries.xs}px) {
    right: calc(50% - 175px);
    width: 150px;
    height: 68px;
    bottom: 0;
  }
`;

const FooterLogo = styled.a`
  position: absolute;
  z-index: 2;
  display: block;

  width: 250px;
  height: 100px;

  bottom: 5vh;
  right: 50%;

  background: url(${ImgWuitusu}) no-repeat center / contain;

  @media (max-width: 1400px) {
    right: 250px;
  }
  @media (max-width: ${mediaQueries.lg}px) {
    right: 100px;
  }
  @media (max-width: ${mediaQueries.md}px) {
    right: 50%;
  }
  @media (max-width: ${mediaQueries.xs}px) {
    width: 150px;
    height: 68px;
    bottom: 0;
  }
`;

const data = [
  {
    title: "Crossbody Bag, Victor Over Triple",
    text:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    image: ImgProductOne,
    price: "$29.99",
    link: ""
  },
  {
    title: "Crossbody Bag, We Walk By Faith",
    text:
      "We get it... It’s hard sometimes to feel and embrace the truth that we are valued and made to shine with eachother by using the gifts we have from a walk thats uniquely our own. We need to remember from where that vestige of glory comes, and come together whenever we see it fade.",
    image: ImgProductTwo,
    price: "$29.99",
    link: ""
  }
];

export default () => {
  return (
    <ContainerMain>
      <ProductContainer>
        {data.map(item => (
          <ProductWrapper>
            <Image
              css={css`
                background: url(${item.image}) no-repeat center / contain;
              `}
            />
            <Title>{item.title}</Title>
            <Text>{item.text}</Text>
            <div
              css={css`
                width: 100%;
                display: flex;
                text-align: right;
                justify-content: flex-end;
                align-items: center;
              `}
            >
              <span
                css={css`
                  margin-right: 15px;
                  font-family: Assistant;
                  font-size: 1.5rem;
                `}
              >
                {item.price}
              </span>
              <LinkPurchaseExt href={item.link}>Purchase</LinkPurchaseExt>
            </div>
          </ProductWrapper>
        ))}
      </ProductContainer>
      <FooterSponsor href="Shopify.com" />
      <FooterLogo href="https://wuitusu.com/" />
      <FireFly />
      <ImgBackgroundPhoneCarrierProduct />
    </ContainerMain>
  );
};
